export const handleApiResponse = async (response) => {
    const contentType = response.headers.get("content-type");
    const isJson = contentType && contentType.includes("application/json");

    if (!response.ok) {
        let errorMessage = 'Something went wrong';
        let errorCode;
        
        try {
            if (isJson) {
                const errorPayload = await response.json();
                errorMessage = errorPayload.message || errorPayload.error || JSON.stringify(errorPayload);
                errorCode = errorPayload.code;
            } else {
                errorMessage = await response.text();
            }
        } catch (e) {
            errorMessage = response.statusText || 'Failed to process response.';
        }

        console.error("Server Error Response:", { status: response.status, message: errorMessage, code: errorCode });
        const error = new Error(errorMessage);
        if (errorCode) {
            error.code = errorCode;
        }
        throw error;
    }

    if (isJson) {
        return response.json();
    }
};